<script setup lang="ts">
import type { Schemas } from '../api/http'
import UiField from './UiField.vue'

/** Company legal data inputs; errors come from problem.errors as `legal.<field>`. */
const legal = defineModel<Schemas['Legal']>({ required: true })
defineProps<{ fieldErr: (field: string) => string; disabled?: boolean }>()
</script>

<template>
  <fieldset class="legal" :disabled="disabled">
    <legend>{{ $t('legal.title') }}</legend>
    <div class="grid-2">
      <UiField :label="$t('legal.legalName')" :error="fieldErr('legal.legal_name')">
        <input v-model.trim="legal.legal_name" name="legal_name" required maxlength="200" :aria-invalid="!!fieldErr('legal.legal_name')" />
      </UiField>
      <UiField :label="$t('legal.regNumber')" :error="fieldErr('legal.reg_number')" :hint="$t('legal.regNumberHint')">
        <input v-model.trim="legal.reg_number" name="reg_number" required inputmode="numeric" pattern="[0-9]{11}" :aria-invalid="!!fieldErr('legal.reg_number')" />
      </UiField>
      <UiField :label="$t('legal.vatNumber')" :error="fieldErr('legal.vat_number')">
        <input v-model.trim="legal.vat_number" name="vat_number" maxlength="20" placeholder="LV40003000000" :aria-invalid="!!fieldErr('legal.vat_number')" />
      </UiField>
      <UiField :label="$t('legal.address')" :error="fieldErr('legal.address')">
        <input v-model.trim="legal.address" name="address" required maxlength="300" :aria-invalid="!!fieldErr('legal.address')" />
      </UiField>
      <UiField :label="$t('legal.iban')" :error="fieldErr('legal.iban')">
        <input v-model.trim="legal.iban" name="iban" maxlength="34" :aria-invalid="!!fieldErr('legal.iban')" />
      </UiField>
      <UiField :label="$t('legal.bankName')" :error="fieldErr('legal.bank_name')">
        <input v-model.trim="legal.bank_name" name="bank_name" maxlength="100" :aria-invalid="!!fieldErr('legal.bank_name')" />
      </UiField>
    </div>
  </fieldset>
</template>

<style scoped>
.legal {
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 1rem;
  margin: 0;
  min-width: 0;
}
legend {
  padding: 0 0.4rem;
  font-weight: 500;
  font-size: 0.9rem;
}
</style>
